import { render, staticRenderFns } from "./DisplayComments.vue?vue&type=template&id=716522fc"
import script from "./DisplayComments.vue?vue&type=script&lang=ts"
export * from "./DisplayComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports